import rpm from "@cached/rpm.json";
import rangeZone from "@cached/zona_range.json";
import _percorsi  from '@src/js/vue/mixins/percorsi.js'
import garminSteps  from '@src/cached/json/garmin_steps.json'
import _sport from '@src/cached/json/sport.json'

const nuotoStile = garminSteps.andatura_stile;
const nuotoAttrezzatura = garminSteps.andatura_attrezzatura;

const testoNote = function (context) {
    const value = context && context.andatura_note;
    return (typeof value === 'string') ? value.trim() : '';
}

// Il formatter HTML finisce in v-html (MspAndatura, MspAndatureDettaglio).
const escapeHtml = function (text) {
    return text.replace(/[&<>"']/g, (c) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    })[c]);
}

const optionsPercorso = _percorsi.percorsi.map((el)=>({
    id: el.codice,
    label: el.nome,
}));


// Testo di un intervallo di valori (rpm, valori della zona dal test dell'atleta):
// unica regola per tutte le descrizioni dell'andatura. Gemello PHP: FormatText::formatIntervallo().
export const formatIntervallo = function (da, a) {
    return `${da} - ${a}`;
}

export const settings = {
    classLabel: "option-label"
}

export const sportConfig = {
    "ciclismo": [
        "rpm",
        "zona_range",
        "percorso",
        "note",
        "lap",
    ],
    "podismo": [
        "zona_range",
        "note",
        "lap",
    ],
    "sci": [
        "zona_range",
        "note",
        "lap",
    ],
    "nuoto": [
        "zona_range",
        "stile",
        "attrezzatura",
        "note",
        "lap",
    ],
}

export const config = [
    {
        "id": "zona_range",
        "type": "zona-range",
        "className": "andatura-zona-range",
        "inline": true,
        "params": {
            "label": "Range",
            "keyAndatura": "andatura_zona_range",
            "options": rangeZone,
            "optionKey": "id",
            "optionValue": "id",
            "optionLabel": "nome",
        },
        "view": {
            "hidden": true,
        }
    },
    {
        "id": "rpm",
        "type": "rpm",
        "className": "",
        // inline: selettore nella riga principale dell'andatura, accanto alla zona,
        // invece che nel pannello opzioni.
        "inline": true,
        "params": {
            "label": "RPM",
            "format": "number",
            "keyAndatura": ["andatura_rpm_da","andatura_rpm_a"],
            "options": rpm,
            "optionKey": "id",
            "optionValue": "id",
            "optionLabel": "label",
        },
        "view": {
            "formatter": function (field, context) {
                void(field);
                return `@ ${formatIntervallo(context.andatura_rpm_da, context.andatura_rpm_a)} <span class='um'>rpm</span>`;
            },
            "formatterPlainText": function (field, context) {
                void(field);
                return `@ ${formatIntervallo(context.andatura_rpm_da, context.andatura_rpm_a)} rpm`;
            },
            "emptyFunction": function (field, context) {
                return !(+context.andatura_rpm_da + (+context.andatura_rpm_a));
            },
            "prefix": "@ ",
            "suffix": "rpm"
        }
    },
    {
        "id": "percorso",
        "type": "select",
        "className": "andatura-percorso",
        "params": {
            "label": "Percorso",
            "keyAndatura": "andatura_percorso",
            "options": optionsPercorso,
            "optionKey": "id",
            "optionValue": "id",
            "optionLabel": "label",
        },
        "view": {
            "formatter": "{{andatura_percorso}}",
            "type": "select",
            "emptyFunction": function (field, context) {
                const value = getFieldValue(field, context);
                return !(value && value.length) || (value === 'nessuno');
            }
        }
    },
    {
        "id": "stile",
        "type": "select",
        "className": "andatura-stile",
        "params": {
            "label": "Stile",
            "keyAndatura": "andatura_stile",
            "options": nuotoStile,
            "optionKey": "codice",
            "optionValue": "codice",
            "optionLabel": "label",
        },
        "view": {
            "formatter": "{{andatura_stile}}",
            "type": "select",
        }
    },
    {
        "id": "attrezzatura",
        "type": "select",
        "className": "andatura-attrezzatura",
        "params": {
            "label": "Attrezzatura",
            "keyAndatura": "andatura_attrezzatura",
            "options": nuotoAttrezzatura,
            "optionKey": "codice",
            "optionValue": "codice",
            "optionLabel": "label",
        },
        "view": {
            "formatter": "con {{andatura_attrezzatura}}",
            "type": "select",
        },
    },
    {
        // Testo libero.
        "id": "note",
        "type": "text",
        "params": {
            "label": "Note",
            "keyAndatura": "andatura_note",
        },
        "view": {
            "formatter": function (field, context) {
                void(field);
                return escapeHtml(testoNote(context));
            },
            "formatterPlainText": function (field, context) {
                void(field);
                return testoNote(context);
            },
            "emptyFunction": function (field, context) {
                void(field);
                return !testoNote(context).length;
            },
        }
    },
    {
        // Checkbox "Premi tasto LAP", ultima opzione del pannello e della descrizione.
        "id": "lap",
        "type": "lap",
        "params": {
            "label": "LAP",
            "title": "Premi tasto LAP per procedere",
            "keyAndatura": "lap",
        },
        "view": {
            "formatter": function (field, context) {
                return (descrizioneTastoLap(field, context) || "").trim();
            },
            "emptyFunction": function (field, context) {
                void(field);
                return !context.lap;
            },
            // newLine: nella descrizione l'opzione va su una nuova riga (testo semplice:
            // "\n"; HTML: classe option--new-line), invece di seguire le altre.
            "newLine": true,
            // descrizioneGarmin false: esclusa dalla descrizione dello step Garmin
            // (export PHP, MSP_Garmin::getDescrizioneAndatura), che la traduce in una
            // funzione del device. Gemello di FormatText.php.
            "descrizioneGarmin": false,
        }
    },
];

// Campi dell'andatura elencati in sportConfig per lo sport, nell'ordine di config.
// Gemello PHP: FormatText::filteredConfigAndatura().
export const configAndaturaSport = function (sport_id) {
    const sport = _sport.find(el => +el.id === +sport_id);
    if (!sport) return [];
    const keys = sportConfig[sport.codice];
    if (!(keys && keys.length)) return [];
    return config.filter(el => keys.indexOf(el.id) !== -1);
}

const findSelectedOption = function (key, field, context) {
    const value = context[key];
    const optionValue = field.params.optionValue || "id";
    const optionLabel = field.params.optionLabel || "label";

    const item = field.params.options.find((el)=>{
        if (el.is_hidden) return false;

        return el[optionValue]===value;
    });

    if (item) {
        if (!item.is_hidden) {
            return item[optionLabel];
        } else {
            return "";
        }
    }
}

export const fieldIsEmpty = function (field, context) {
    if (!field.view) return true;
    if (field.view.hidden) return true;
    if (typeof field.view.emptyFunction === 'function') {
        
        return field.view.emptyFunction(field,context);
    }

    if (field.view.type === 'select') {
        const key = field.params.keyAndatura;
        const selectedOption = findSelectedOption(key, field, context);
        if (!selectedOption) {

            return true;
        } else {

            return false;
        }
    }

    const value = getFieldValue(field, context);
    if (!(value && value.length)) return true;
    
    return false;
}

export const formatText = function (field, context, isPlainText) {
    if (fieldIsEmpty(field, context)) {

        return "";
    }

    const formatter = (isPlainText && field.view.formatterPlainText) ? "formatterPlainText" : "formatter";
    if(field.view[formatter]) {
        if (typeof field.view[formatter] === 'function') {
            return field.view[formatter](field, context);  // Chiamata alla funzione
        }

        let hasMissingValue = false; // Flag per controllare se ci sono valori mancanti
        const formattedText = field.view[formatter].replace(/\{\{(.*?)\}\}/g, (match, key) => {
            key = key.trim();

            if (context && context[key] !== undefined) {

                if (field.view.type === 'select') {
                    const selectedOption = findSelectedOption(key, field, context);
                    if (selectedOption) {

                        return selectedOption

                    } else {
                        hasMissingValue = true;

                        return "";
                    }

                }

                return context[key];
            }

            hasMissingValue = true;

            return "";

        });
        return hasMissingValue ? "" : formattedText;
    } else {
        return getFieldValue(field, context);
    }

}
export const descrizioneTastoLap = function (field, context) {
    void(field);

    return (context.lap) ? 'LAP' : null;
}

// Restituisci il valore del campo, nel caso in cui non esista un formatter
export const getFieldValue = function (field, context) {
    if (field.params.keyAndatura && Array.isArray(field.params.keyAndatura)) {
        return formatIntervallo(...field.params.keyAndatura.map(key => context[key]));
    }
    return context[field.params.keyAndatura] || '';
}

export default config;
